import {
    MobileGift50BonusContainerStyled,
    MobileGift50BonusContentStyled,
    MobileGift50BonusStyled,
} from "./styled/MobileGift50BonusStyled";
import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getBonusActiveGift50 } from "../../Bonus/bonusesSelectors";
import ToAppButton from "../../../components/ToAppButton/ToAppButton";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

function MobileGift50Bonus(props) {
    const {pushGtmEvent} = useGTMEvent({module: 'Gift50Bonus'});
    const {getLangPath} = useLangContext();

    const handleGetAppClick = useCallback(() => {
        pushGtmEvent({button: 'GetTheApp', event: 'click'});
    }, [pushGtmEvent]);

    return (
            <MobileGift50BonusStyled>
                <MobileGift50BonusContainerStyled>
                    <MobileGift50BonusContentStyled>
                        <img src="/assets/bonus/bonus-gift-50-icon.svg" alt="bonus-gift-50-icon"/>
                        <h1 className="mt-2 mb-4">{getLangPath('bonus.gift50.welcome_title')}</h1>
                        <p>{getLangPath('welcome.download_app')}</p>
                    </MobileGift50BonusContentStyled>
                    <div className="d-flex flex-column">
                        <ToAppButton>
                            <Button
                                    className="mt-4"
                                    size="lg"
                                    variant="primary"
                                    onClick={handleGetAppClick}
                            >
                                {getLangPath('onboarding.get_app_button')}
                            </Button>
                        </ToAppButton>
                    </div>
                </MobileGift50BonusContainerStyled>
            </MobileGift50BonusStyled>
    )
}

const mapStateToProps = createStructuredSelector({
    bonusActiveGift50: getBonusActiveGift50,
})

export default connect(mapStateToProps)(MobileGift50Bonus);
